import * as libCon from '../community-hats-js-library/Constants';
import * as locCon from '../LocalConstants';
import { RefATOField, setStoredValue } from '../hooks/StoreHooks';
import { RefContextLanguage } from '../providers/LanguageProvider';
import { useCallback, useEffect, useState } from 'react';
import CustomSpin from '../elements/CustomSpin';
import { goToThirdPartyLink, isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { CustomPrimaryButtonWithDisability } from '../elements/CustomButton';
import { getFitbitAuthURLForEmail } from '../community-hats-js-library/back-end/router';
import { showErrorDialogByCode } from '../utils/dialogFunctions';

// Opens the Fitbit consent page for the account currently in the store.
//
// Shared by BundleSetUp and ReplaceEmail, which both used to build the URL
// inline. They cannot any more: the consent link now carries a state signed
// with the server's secret and a redirect URI that has to match the callback,
// so it has to be fetched.
//
// That fetch happens on mount, not in the click handler. goToThirdPartyLink is
// window.open, and a window.open after an await is outside the user's gesture,
// so the browser blocks it — which in the installed PWA reads as a dead button.
//
// The link is only good for ten minutes and only once. Re-mounting the page, or
// the Restart Process button, is what gets a fresh one.
export function FitbitAuthorizeButton({ checkboxId = null }) {
  const i18n = RefContextLanguage();

  const email = RefATOField(locCon.AT_OBJECT_EMAIL_ACCOUNT, libCon.ATF_EMAIL);

  const [authUrl, setAuthUrl] = useState(() => null);
  const [loadingUrl, setLoadingUrl] = useState(false);

  const loadAuthURL = useCallback(async () => {
    if (isNullOrUndefined(email)) return;

    setLoadingUrl(true);
    setAuthUrl(null);

    const [status, url] = await getFitbitAuthURLForEmail(email);

    if (status === libCon.OK) setAuthUrl(url);
    else showErrorDialogByCode(status);

    setLoadingUrl(false);
  }, [email]);

  useEffect(() => {
    loadAuthURL();
  }, [loadAuthURL]);

  if (loadingUrl) return <CustomSpin type={locCon.BUTTON_SPINNER} />;

  return (
    <CustomPrimaryButtonWithDisability
      isDisabled={isNullOrUndefined(authUrl)}
      title={i18n.t('missingValues')}
      description={isNullOrUndefined(email) ? libCon.ATF_EMAIL : i18n.t('error')}
      onClick={() => {
        goToThirdPartyLink(authUrl);
        setStoredValue(checkboxId, true);
      }}
    >
      {i18n.t('authorizeApp')}
    </CustomPrimaryButtonWithDisability>
  );
}

export default FitbitAuthorizeButton;
